var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBpro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6984 25.2027C20.6377 25.2027 25.4525 20.3879 25.4525 14.4486C25.4525 8.50934 20.6377 3.69458 14.6984 3.69458C8.75909 3.69458 3.94434 8.50934 3.94434 14.4486C3.94434 20.3879 8.75909 25.2027 14.6984 25.2027Z",
    stroke: "#4BB869",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7109 14.4486V9.66907H16.0974C18.7166 9.66907 19.0846 13.562 16.6423 14.4486M11.7109 14.4486V19.2282H16.0974C18.7166 19.2282 19.0846 15.3353 16.6423 14.4486M11.7109 14.4486H16.6423",
    stroke: "#4BB869",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpro);
export default __webpack_public_path__ + "static/media/bpro.011d1a0ef234f119df4918dc244178fa.svg";
export { ForwardRef as ReactComponent };